// LAP-550 — Card Valeur Investissement (header unifié + chart aéré + empty state)
import { Box } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import CardHeader from '../../_shared/CardHeader'
import EmptyState from '../../_shared/EmptyState'
import { formatMoney } from '../../_shared/gridCols'

export default function InvestmentValue({ report }) {
  const { t, i18n } = useTranslation('layout')
  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      datalabels: { display: false },
      legend: {
        display: true,
        position: 'bottom',
        labels: { color: 'rgba(255,255,255,0.7)', font: { size: 11 }, usePointStyle: true },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
          title: () => null,
        },
      },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          color: 'rgba(255,255,255,0.55)',
          callback: function (e) {
            return moment(data.labels[e]).format('MMM')
          },
        },
        grid: { color: 'rgba(255,255,255,0.05)' },
      },
      y: {
        stacked: false,
        ticks: {
          color: 'rgba(255,255,255,0.55)',
          // Jamais de longue traîne décimale (1131.8000000000002) sur l'axe.
          callback: (v) => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 2 }),
        },
        grid: { display: true, color: 'rgba(255,255,255,0.06)' },
      },
    },
  }
  const [data, setRevData] = useState({
    labels: ['2022', '2023', '2024', '2025'],
    datasets: [
      {
        label: '',
        data: [1, 2, 2.5, 6],
        backgroundColor: ['#60829b'],
        borderColor: ['#60829b'],
        barThickness: 10,
      },
    ],
  })
  useEffect(() => {
    setRevData({
      labels: report?.labels,
      datasets: [
        {
          label: t('investments.portfolio.invValue.activePortfolio'),
          data: report?.portfolio,
          backgroundColor: '#63a0ff',
          borderColor: '#63a0ff',
          tension: 0.35,
          pointRadius: 3,
          pointBackgroundColor: '#63a0ff',
          barThickness: 10,
        },
        {
          label: t('investments.portfolio.invValue.profitability'),
          data: report?.profitability,
          backgroundColor: '#a78bfa',
          borderColor: '#a78bfa',
          tension: 0.35,
          pointRadius: 3,
          pointBackgroundColor: '#a78bfa',
          barThickness: 10,
        },
      ],
    })
  }, [report, t, i18n.language])

  const change = report?.change
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />}
        title={t('investments.portfolio.invValue.title')}
        subtitle={t('investments.portfolio.invValue.yearlyChange')}
        value={report?.total !== undefined ? formatMoney(report?.total) : null}
        delta={change !== undefined ? { value: change, unit: '%' } : null}
      />
      {/* flex:1 + minHeight:0 : le chart (maintainAspectRatio:false) remplit
          l'espace restant de la card SANS déborder sous le CardHeader. */}
      <Box
        mt={2}
        flex={1}
        minHeight={0}
        position="relative"
        sx={{ borderTop: '1px dashed rgba(255,255,255,0.08)', pt: 1.5 }}
      >
        {report?.labels?.length > 0 ? (
          <Line data={data} options={optionsbar} />
        ) : (
          <EmptyState label={t('investments.portfolio.noInvestmentsYet')} />
        )}
      </Box>
    </Box>
  )
}
